// extracted by mini-css-extract-plugin
export default {"container":"styles_container__L469N","active":"styles_active__Gws7A","text":"styles_text__cEehN","icon":"styles_icon__uIATp"};